<template>

  <v-toolbar-title>

    <v-list-item dark class="pl-0">

      <router-link to="/">

        <v-img :src="require('@/styles/videocms_streamon logo_white.png')" />  

      </router-link>
    </v-list-item>

  </v-toolbar-title>
</template>
<script>
export default {
  name: 'AppLogo'
}
</script>
